import React from 'react';
import { AutocompleteInput } from 'react-admin';

const choices = [
    { id: 'oneoff', name: 'One-off' },
    { id: 'monthly', name: 'Monthly' },
    { id: 'quarterly', name: 'Quarterly' },
    { id: 'yearly', name: 'Yearly' },
    { id: 'biyearly', name: 'Bi-yearly' },
    { id: 'weekly', name: 'Weekly' },
];


const CostFrequencyInput = ({ classes, record, source = "frequency", ...props }) => {
    if (record && record[source] && !choices.find((item) => item.id === record[source])) {
        choices.push({ id: record[source], name: record[source] });
    }

    return (
        <AutocompleteInput choices={choices} source={source} record={record} allowEmpty {...props} />
    );
};

export default CostFrequencyInput;
